'use strict';
import angular from 'angular';
import moment from 'moment';

export default class FormationController {
  /*@ngInject*/
  constructor($stateParams, $location, $http, $state, $timeout, $scope, Borne, appConfig, $sce, $rootScope) {
    var vm = this;
    var iterator = 0;
    var iteratorQuestion = 0;
    vm.loading = true;
    vm.end = false;
    vm.electron = window.electron;
    vm.availableImages = ['JPG', 'jpg', 'PNG', 'png', 'gif'];
    vm.availableVideos = ['mp3', 'mp4', 'avi', 'mkv'];
    $('.modal-backdrop').hide();

    if (!Borne.Poste) {
      Borne.load($stateParams.borneId).then(function() {
        initPage();
        $scope.$apply();
      })
    } else {
      initPage();
    }

    function initPage() {
      Borne.Poste.Session.questions = {};
      Borne.Poste.Session.questions.badAnwsers = [];
      Borne.Poste.questions = {
        correctAnswerCount: 0
      }
      vm.borne = angular.copy(Borne.Poste);
      vm.categorie = _.find(Borne.Poste.Categories, ['_id', $stateParams.id]);
      vm.formations = vm.categorie.Formations.sort(function(a, b) { return (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0); });
      vm.formations = _.filter(vm.formations, 'active')
      vm.formation = vm.formations[0];
      vm.formationRunning = true;
      setMedia();
    }

    $('#supportVideo').on('play', function() {
      // document.getElementById("supportVideo").currentTime =  document.getElementById("supportVideo").duration - 2
    })

    $('#supportVideo').on('ended', function() {
      if (vm.currentSupport.type == 'gSlide') return
      Borne.startTimer();
      vm.end = true;
      $scope.$apply();
      document.getElementById("supportVideo").pause();
    })

    vm.restart = function() {
      vm.end = false;
      iterator = 0;
      setMedia();
      document.getElementById("supportVideo").src = vm.source;
    }

    vm.suivant = function() {
      if (iterator < vm.formation.supports.length - 1) {
        vm.end = false
        iterator++
        setMedia();
      } else if (vm.formation.questions.length == 0) {
        vm.suivantQuestions();
      } else {
        Borne.startTimer();
        vm.formationRunning = false;
        vm.questionRunning = true;
        setQuestionMedia();
      }
    }

    vm.selectAnswer = function(reponse) {
      reponse.selected = !reponse.selected
    }

    vm.fitToMedia = function() {
      if (vm.currentQuestion && vm.currentQuestion.mediaPath) return 'col-md-6'
      else return 'col-md-12 text-center'
    }

    vm.noAnswer = function() {
      if (vm.currentQuestionLangue) {
        if (_.filter(vm.currentQuestionLangue.reponses, 'selected').length > 0) return false
        else return true
      }
    }

    vm.validerQuestions = function() {
      vm.isAnswered = true;
      vm.echec = false;
      if (_.filter(vm.currentQuestionLangue.reponses, ['selected', true]).length != _.filter(vm.currentQuestionLangue.reponses, ['correcte', true]).length) vm.echec = true;
      _.map(vm.currentQuestionLangue.reponses, function(reponse, index) {
        if (!reponse.selected) return
        if (!reponse.answered) reponse.answered = 1
        else reponse.answered++
          if (reponse.correcte) {
            Borne.Poste.questions.correctAnswerCount += 1;
          } else {
            vm.echec = true;
            if (_.find(Borne.Poste.Session.questions.badAnwsers, { question: vm.currentQuestion.name, reponse: reponse.reponse })) _.find(Borne.Poste.Session.questions.badAnwsers, { question: vm.currentQuestion.name }).number++
              else if (_.find(Borne.Poste.Session.questions.badAnwsers, { question: vm.currentQuestion.name, reponse: reponse.number + 1 })) _.find(Borne.Poste.Session.questions.badAnwsers, { question: vm.currentQuestion.name }).number++
                else if (vm.currentQuestion.type == 'image') Borne.Poste.Session.questions.badAnwsers.push({ question: vm.currentQuestion.name, reponse: reponse.number + 1, number: 1 })
            else Borne.Poste.Session.questions.badAnwsers.push({ question: vm.currentQuestion.name, reponse: reponse.reponse, number: 1 })
          }
      })
      $timeout(vm.suivantQuestions, 1000);
    }

    vm.suivantQuestions = function() {
      if (!vm.echec) {
        vm.isAnswered = false;
        if (vm.formation.questions.length > 0 && iteratorQuestion < vm.formation.questions.length - 1) {
          iteratorQuestion++
          setQuestionMedia();
        } else {
          if (vm.formations.indexOf(vm.formation) + 1 == vm.formations.length) {
            $('#engagement').modal('show')
          } else {
            iteratorQuestion = 0;
            iterator = 0
            vm.formation = vm.formations[vm.formations.indexOf(vm.formation) + 1];
            vm.formationRunning = true;
            vm.questionRunning = false;
            setMedia();
          }
        }
      } else {
        $('#restartModal').modal('show');
        Borne.Poste.questions.correctAnswerCount = 0;
        vm.attemptCount++;
      }
    }

    vm.next = function() {
      $('#engagement').modal('hide')
      setTimeout(function() {
        Borne.startTimer();
        if (vm.electron && !Borne.Poste.selectedCategorie.impression) {
          Borne.Poste.Session.category = {
            name: vm.categorie.name,
            _id: vm.categorie._id
          }
          Borne.Poste.Session.site = {
            _id: Borne.Poste.Site._id,
            name: Borne.Poste.Site.name
          }
          if (Borne.Poste.Session.badge) {
            var badge = Borne.Poste.Session.badge
            if (badge.active && badge.session.entrees) _.last(badge.session.entrees).sortie = new Date;
            if (!badge.session.entrees) badge.session.entrees = [{ date: new Date }];
            else badge.session.entrees.push({ date: new Date });
            badge.active = true;
            badge.exitTime = vm.categorie.autoEndTimer;
            var expiryDate = moment(vm.borne.collecte.expiryDate).toDate();
            $http.patch('/api/badges/' + badge._id, badge).then(function(resp) {
              setTimeout(function() {
                vm.loading = false;
                $('#endModal').modal('show');
                $scope.$apply();
              }, 250)
            })
          } else {
            var expiryDate = moment(vm.borne.collecte.expiryDate).toDate();
            Borne.Poste.Session.entrees = [{ date: new Date }];
            $http.post('/api/badges', { name: vm.borne.collecte.Nom + ' ' + vm.borne.collecte.Prenom, exitTime: vm.categorie.autoEndTimer, session: Borne.Poste.Session, expiryDate: expiryDate, active: true, emails: _.map(Borne.Poste.Session.collecte.contacts, 'email') }).then(function(resp) {
              setTimeout(function() {
                $('#endModal').modal('show');
                vm.loading = false;
                $scope.$apply();
              }, 250)
            })
          }
        } else if (vm.electron) {
          $('#validateModal').modal('show')
        } else {
          $('#printModal').modal('show')
          vm.print()
        }
        $scope.$apply()
      }, 250)
    }


    vm.restart = function() {
      $('#restartModal').modal('hide');
      vm.resetFormation();
    }

    vm.print = function() {
      vm.borne.collecte.createdAt = moment(new Date).format('DD/MM/YYYY H:mm');
      vm.borne.collecte.expiryDate = moment().add(vm.categorie.expiryDate, 'd').format('DD/MM/YYYY H:mm');
      vm.borne.collecte.session = Borne.Poste.Session.questions;
      vm.borne.collecte.session.category = {
        name: vm.categorie.name,
        _id: vm.categorie._id
      }
      vm.borne.collecte.session.site = {
        _id: Borne.Poste.Site._id,
        name: Borne.Poste.Site.name
      }
      vm.borne.collecte.session.langue = Borne.Poste.Langue.id;
      $http.get(`api/categories/alert/download/${vm.categorie._id}`);
      $http.post('/api/qr-codes/printQrcode', vm.borne.collecte).then(function(resp) {
        vm.html = resp.data.html;
        var popup = window.open('', 'APERAM PRINTING QRCODE');
        if (!popup) {
          // vm.showErrorPrintMessage = true
        } else {
          $('#printModal').modal('hide');
          popup.document.write(vm.html);
          $timeout(function() {
            popup.print();
            popup.close();
            vm.borne.returnToMain();
          }, 250)
        }
      })
    }

    vm.printBack = function() {
      // vm.showErrorPrintMessage = false;
      var popup = window.open('', 'APERAM PRINTING QRCODE');
      if (!popup) {
        // vm.showErrorPrintMessage = true;
      } else {
        popup.document.write(vm.html);
        $timeout(function() {
          popup.print();
          popup.close();
          vm.borne.returnToMain();
        }, 250)
      }
    }

    vm.printBadge = function(impression) {
      if (impression) {
        $('#validateModal').modal('hide');
        setTimeout(function() {
          console.log(Borne.Poste.Session.questions.badAnwsers)
          $rootScope.badAnwsers = Borne.Poste.Session.questions.badAnwsers
          $location.path('/borne_badge/' + vm.categorie._id + '/' + $stateParams.borneId);
          $scope.$apply();
        }, 250)
      } else {
        console.log('pas d\'impression');
      }
    }

    $scope.trustSrc = function(src) {
      return $sce.trustAsResourceUrl(src);
    }

    $scope.$on('$destroy', function() {
      vm.resetFormation(true);
    })

    vm.resetFormation = function(full, medium) {
      $('#engagement').modal('hide');
      if (full) {
        vm.formation = vm.formations[0];
        Borne.Poste.Session.questions = {};
        Borne.Poste.Session.questions.badAnwsers = [];
        Borne.Poste.questions = {
          correctAnswerCount: 0
        }
        iteratorQuestion = 0;
      }
      iterator = 0;
      vm.isAnswered = false;
      vm.formationRunning = true;
      vm.questionRunning = false;
      setMedia();
      _.map(vm.formations, function(formation) {
        _.map(formation.questions, function(questions) {
          _.map(questions.langues, function(langue) {
            _.map(langue.reponses, function(reponse) {
              reponse.selected = undefined;
            })
          })
        })
      })
    }

    function setMedia() {
      vm.end = false;
      vm.currentSupport = vm.formation.supports[iterator];
      vm.currentSupportLangue = vm.currentSupport.langues[vm.currentSupport.langues.indexOf(_.find(vm.currentSupport.langues, ['langueId', vm.borne.Langue.id]))];
      if (vm.currentSupport.type == "gSlide") {
        Borne.stopTimer();
        $timeout(function() {
          vm.end = true;
          Borne.startTimer();
        }, vm.currentSupport.slideCount * (vm.currentSupport.slideTime * 1000))
      }
      vm.source = `${vm.currentSupportLangue.mediaPath}`;
      if (vm.currentSupport.type != "gSlide" && vm.availableImages.includes(vm.currentSupportLangue.mediaPath.slice(vm.currentSupportLangue.mediaPath.lastIndexOf('.') + 1))) vm.end = true;
      if(vm.currentSupport.type != "gSlide" && vm.currentSupportLangue.mediaPath && vm.availableVideos.includes(vm.currentSupportLangue.mediaPath.slice(vm.currentSupportLangue.mediaPath.lastIndexOf('.') +1))) Borne.stopTimer();
    }

    function setQuestionMedia() {
      vm.currentQuestion = vm.formation.questions[iteratorQuestion];
      vm.currentQuestionLangue = vm.currentQuestion.langues[vm.currentQuestion.langues.indexOf(_.find(vm.currentQuestion.langues, ['langueId', vm.borne.Langue.id]))];
      vm.source = `${vm.currentQuestionLangue.mediaPath}`;
      if (vm.currentQuestionLangue.mediaPath && vm.availableImages.includes(vm.currentQuestionLangue.mediaPath.slice(vm.currentQuestionLangue.mediaPath.lastIndexOf('.') + 1))) vm.end = true;
      vm.currentQuestionLangue.reponses = shuffle(vm.currentQuestionLangue.reponses);
      // document.getElementById("supportVideoQuestion").src = vm.source
    }

    function shuffle(array) {
      var currentIndex = array.length,
        temporaryValue, randomIndex;
      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/borne/formation/formation.controller.js